<template>
  <div class="row mt-3 px-3 py-2 mx-1" :class="background">
    <div class="col-md-3">
      <img class="mt-3" :src="require('@/assets/img/' + image + '')" />
    </div>
    <div class="col-md-9">
      <p class="font-14 mb-0 font-weight-normal">{{ content }}</p>
      <p class="font-24 mt-0 font-weight-bold">
        {{ count.toLocaleString() }}
        <span
          v-if="hasBadge"
          :class="badgeClass"
          class="rounded-pill font-10 font-weight-normal text-light mt-1 mr-3 px-2 py-1 float-right"
        >
          {{ badgePercent }}%
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailGeneralInfoPanel",
  components: {},
  props: {
    count: {
      type: Number,
      default: 0,
    },
    background:{
      type: String,
      default: ()=> 'bg-secondary-3'
    },
    content: {
      type: String,
      default: "",
    },
    hasBadge: {
      type: Boolean,
      default: false,
    },
    badgePercent: {
      type: Number,
      default: 0,
    },
    image: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    borderClass: null,
    textClass: null,
  }),
  computed: {
    badgeClass() {
      if (this.badgePercent > 9) return "bg-danger";

      return "bg-success";
    },
  },
};
</script>
